module.exports = __webpack_public_path__ + "img/barcode-img.2a37645b.png";